export namespace Scheduling {
  export enum CompensationType {
    PAID = 'PAID',
    UNPAID = 'UNPAID',
  }

  export enum BreakType {
    PLANNED = 'PLANNED',
    ACTUAL = 'ACTUAL',
  }

  export enum ShiftTable {
    PLANNED = 'planned_shift',
    ACTUAL = 'actual_shift',
  }

  export enum ShiftType {
    PLANNED = 'PLANNED',
    ACTUAL = 'ACTUAL',
  }

  export enum ScheduleStatus {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED',
  }

  export enum ScheduleEditReason {
    CREATED = 'CREATED',
    EMPLOYEE_REQUESTED = 'EMPLOYEE_REQUESTED',
    EMPLOYEE_VOLUNTARY_FILL_IN = 'EMPLOYEE_VOLUNTARY_FILL_IN',
    FORCE_MAJEURE = 'FORCE_MAJEURE',
    DISCIPLINARY_ACTION = 'DISCIPLINARY_ACTION',
    LARGE_EVENT_CHANGE = 'LARGE_EVENT_CHANGE',
    TERMINATED = 'TERMINATED',
  }

  export enum PunchEditReasons {
    FORGOT_TO_CLOCK_IN = 'FORGOT_TO_CLOCK_IN',
    INCORRECT_CLOCK_IN_OUT = 'INCORRECT_CLOCK_IN_OUT',
    INCORRECT_BREAK_IN_OUT = 'INCORRECT_BREAK_IN_OUT',
    INCORRECT_JOBCODE = 'INCORRECT_JOBCODE',
    OTHER = 'OTHER',
  }
}
